module.exports = __webpack_public_path__ + "static/olia-4bbc78fcc8b8b9246e81a76a1a524cce.png";